// extracted by mini-css-extract-plugin
export var billingAddress = "_y5-g";
export var contactInfo = "_y5-d";
export var customerInfoContainer = "_y5-c";
export var customerInfoContainerMobile = "_y5-h";
export var customerInfoRow = "_y5-a";
export var customerInfoSection = "_y5-b";
export var fullWidthDividerMobile = "_y5-i";
export var imageContainer = "_y5-1";
export var paymentMethod = "_y5-e";
export var priceText = "_y5-6";
export var priceTextMobile = "_y5-7";
export var product = "_y5-0";
export var productImage = "_y5-2";
export var productInfo = "_y5-4";
export var productMobile = "_y5-9";
export var productTitle = "_y5-8";
export var quantityBadge = "_y5-3";
export var quantityText = "_y5-5";
export var shippingAddress = "_y5-f";